import { createReducer, on } from '@ngrx/store';
import { setNameInLegendOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { NAME_IN_LEGEND_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
export const nameInLegend = createReducer(NAME_IN_LEGEND_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.nameInLegend), on(setNameInLegendOption, (state, action) => {
    return action.nameInLegend;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.NAME_IN_LEGEND];
}));
